import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  ChevronLeft,
  ChevronRight,
  Heart,
  Minus,
  Plus,
  Share2,
  Weight,
} from "lucide-react";
import { getAllProducts } from "../api/productApi";
import { useAuth } from "../context/AuthContext";
import config from "../config";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import i18next from "i18next";

const ProductDetails = () => {
  const { id } = useParams();

  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [currentImage, setCurrentImage] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const { selectedBranch, setCartTotal,clientData } = useAuth();
  const { t, i18n } = useTranslation();
  // Get cart from localStorage
  const getCart = () => JSON.parse(localStorage.getItem("cart")) || [];

  // Check if the product is already in the cart
  useEffect(() => {
        const cart = getCart();
    const cartItem = cart.find((item) => item.product_id === parseInt(id));
    if (cartItem) {
      setQuantity(cartItem.quantity);
    }
  }, [id]);

  useEffect(() => {
    const cart = getCart();
    const cartItem = cart.find((item) => item.product_id === parseInt(id));
    if (cartItem) {
      setQuantity(cartItem.quantity);
    }
  }, [id]);

  useEffect(() => {
    async function getProductDetails() {
      const filters = {};
      if (selectedBranch?.branch_id) {
        filters.branch_id = selectedBranch.branch_id;
      }
      if (id) {
        filters.product_id = id;
      }

      const data = await getAllProducts(filters);
      const productDetails = data?.find((p) => p.product_id === parseInt(id));

      if (productDetails) {
        const storeInventory = productDetails.storeInventory || [];
        const branchInventory = storeInventory.find(
          (inv) => inv.branch_id === selectedBranch?.branch_id
        );

        let deliveryTime = "";
        let deliveryCost = "";
        let price = branchInventory?.price || productDetails.default_price;
        let currency = branchInventory?.currency || productDetails.default_currency;

        if (selectedBranch) {
          const inStock = branchInventory?.quantity > 0;

          if (!clientData) {
            deliveryTime = inStock
              ? `${selectedBranch.delivery_time} days`
              : `${selectedBranch.delivery_time_out_stock} days`;
            deliveryCost = inStock
              ? `${selectedBranch.delivery_cost} ${currency}`
              : `${selectedBranch.Inter_delivery_cost} ${currency}`;
          } else {
            const isSameCountry = clientData.country === selectedBranch.country;

            if (isSameCountry) {
              deliveryTime = inStock
                ? `${selectedBranch.delivery_time} days`
                : `${selectedBranch.delivery_time_out_stock} days`;
              deliveryCost = inStock
                ? `${selectedBranch.delivery_cost} ${currency}`
                : `${selectedBranch.Inter_delivery_cost} ${currency}`;
            } else {
              deliveryTime = `${selectedBranch.Inter_delivery_time} days`;
              deliveryCost = `${selectedBranch.Inter_delivery_cost} ${currency}`;
            }
          }
        } else {
          deliveryTime = t("SelectCountry");
          deliveryCost = t("SelectCountry");
        }

        setProduct({
          ...productDetails,
          price,
          currency,
          delivery_time: deliveryTime,
          delivery_cost: deliveryCost,
          images: productDetails.productImages.map(
            (img) => config.apiUrl + img.image_url
          ),
        });
      } else {
        setProduct(null);
      }
    }

    getProductDetails();
  }, [id, selectedBranch?.branch_id, clientData]);
  
  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % (product?.images?.length || 1));
  };

  const prevImage = () => {
    setCurrentImage(
      (prev) =>
        (prev - 1 + (product?.images?.length || 1)) %
        (product?.images?.length || 1)
    );
  };

  const handleQuantityChange = (type) => {
    if (type === "increase") {
      setQuantity((prev) => prev + 1);
    } else if (type === "decrease" && quantity > 1) {
      setQuantity((prev) => prev - 1);
    }
  };

  // Handle adding or updating cart
  const handleAddToCart = () => {
    if (!product) return;

    const cart = getCart();
    const existingIndex = cart.findIndex(
      (item) => item.product_id === product.product_id
    );

    const cartItem = {
      product_id: product.product_id,
      name: product.name,
      ar_name: product.ar_name,
      price: product.price,
      currency: product.currency,
      image: product.images[0],
      quantity: quantity,
      delivery_cost: product.delivery_cost,
      delivery_time: product.delivery_time,
      addedAt: new Date(),
      weight: product.weight,
    };

    if (existingIndex !== -1) {
      cart[existingIndex] = { ...cart[existingIndex], ...cartItem, quantity };
    } else {
      cart.push(cartItem);
    }

    localStorage.setItem("cart", JSON.stringify(cart));
    const totalItems = cart.reduce((acc, item) => acc + item.quantity, 0);
    setCartTotal(totalItems);
      // toast.success(t("cartisupdated"));
       navigate("/cart");
  };

  if (!product) {
    return (
      <div className="container mx-auto px-4 py-8 text-center">
        <h1 className="text-2xl font-bold text-gray-800">{t('ProductNotFound')}</h1>
        <p className="text-gray-600 mt-4">
          {t('ProductNotFound.msg')}
        </p>
        <button
          onClick={() => navigate(-1)}
          className="mt-6 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          {t('goback')}
        </button>
      </div>
    );
  }
  const isInCart = getCart().some(
    (item) => item.product_id === product.product_id
  );
const handleShare = async () => {
  const shareData = {
    title: document.title,
    text: 'Check out this product!',
    url: window.location.href,
  };

  if (navigator.share) {
    try {
      await navigator.share(shareData);
    } catch (err) {
      console.error('Error sharing:', err);
    }
  } else {
    // Fallback: copy to clipboard
    try {
      await navigator.clipboard.writeText(shareData.url);
      toast.success("Link copied to clipboard!");
    } catch (err) {
      console.error('Failed to copy:', err);
      toast.error('Unable to share or copy link');
    }
  }
};
const fullImageUrl = `${config.apiUrl}${product.productImages?.[0]?.image_url}`;
const productUrl = window.location.href;
  return (
    <div className="container mx-auto px-4 py-8">


<Helmet>
  <title>{product.name}</title>
  <meta name="description" content={product.description} />

  {/* Open Graph (Facebook/LinkedIn/WhatsApp) */}
  <meta property="og:title" content={product.name} />
  <meta property="og:description" content={product.description} />
  <meta property="og:image" content={fullImageUrl} />
  <meta property="og:type" content="product" />
  <meta property="og:url" content={productUrl} />
  <meta property="og:site_name" content="Delire" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={product.name} />
  <meta name="twitter:description" content={product.description} />
  <meta name="twitter:image" content={fullImageUrl} />

  {/* Schema.org Product Structured Data */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Product",
      name: product.name,
      image: product.productImages.map((img) => `${config.apiUrl}${img.image_url}`),
      description: product.description,
      brand: {
        "@type": "Brand",
        name: "Delire"
      },
      category: product.category?.en_name || "Perfume",
      offers: {
        "@type": "Offer",
        priceCurrency: product.default_currency || "USD",
        price: product.default_price,
        itemCondition: "https://schema.org/NewCondition",
        availability: product.storeInventory?.[0]?.quantity > 0
          ? "https://schema.org/InStock"
          : "https://schema.org/OutOfStock",
        url: productUrl
      }
    })}
  </script>
</Helmet>
      <div className="grid md:grid-cols-2 gap-8">
        {/* Image Gallery */}
        <div className="space-y-4">
          <div className="relative aspect-[3/4] w-full max-h-[400px] overflow-hidden">
            <img
              src={product.images?.[currentImage]}
              alt={product.name || "Product"}
              className="w-full h-full object-contain rounded-lg"
            />
              {product.status ==="inactive" && (
    <div className="absolute inset-0 bg-black/60 flex items-center justify-center z-10 rounded-lg">
      <span className="text-white text-2xl md:text-3xl font-bold tracking-widest">
        {t("SoldOut") || "SOLD OUT"}
      </span>
    </div>
  )}
            <button
              onClick={prevImage}
              className="absolute left-2 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow-lg"
            >
              <ChevronLeft />
            </button>
            <button
              onClick={nextImage}
              className="absolute right-2 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow-lg"
            >
              <ChevronRight />
            </button>
          </div>
          <div className="grid grid-cols-4 gap-2">
            {product.images?.map((img, index) => (
              <button
                key={index}
                onClick={() => setCurrentImage(index)}
                className={`border-2 rounded-lg overflow-hidden ${
                  currentImage === index ? "border-blue-500" : "border-gray-200"
                }`}
              >
                <img src={img} alt={`View ${index + 1}`} className="w-full" />
              </button>
            ))}
          </div>
        </div>

        {/* Product Info */}
        <div className="space-y-6" dir={i18next.language === "ar" ? "rtl" : "ltr"}>
          <div>
            <h1 className="text-3xl font-bold mb-2">
              {" "}
              {i18n.dir() === "rtl" ? product.ar_name : product.name}{" "}
            </h1>
            <p className="text-2xl font-bold text-blue-600">
              {product.price} {product.currency}
            </p>
          </div>

          <div>
            <p className="text-lg text-gray-500">
              <strong>{t('Category')}:</strong>{" "}
              {i18n.dir() === "rtl"
                ? product.category?.ar_name
                : product.category?.en_name}
            </p>
            <p className="text-lg text-gray-500" dir={i18next.language === "ar" ? "rtl" : "ltr"}>
              <strong>{t('DeliveryTime')}: </strong> {product.delivery_time}
            </p>
            {/* <p className="text-lg text-gray-500" dir={i18next.language === "ar" ? "rtl" : "ltr"}>
              <strong>{t('DeliveryCost')}: </strong> {product.delivery_cost === 0
      ? t("Free Delivery")
      : product.delivery_cost}
            </p> */}
          </div>

          {/* Quantity */}
<div>
  {/* style={{ pointerEvents: product.status!=="inactive" ? 'auto' : 'none', opacity: product.status!=="inactive" ? 1 : 0.5 }} */}
  <h3 className="font-medium mb-2">{t('Quantity')}</h3>
  <div className="flex items-center space-x-4">
    <div className="flex items-center border rounded-md opacity-100 md:opacity-100 transition-opacity">
      <button
        onClick={() => handleQuantityChange("decrease")}
        className="p-2 hover:bg-gray-100"
      >
        <Minus size={20} />
      </button>
      <span className="px-4 py-2 border-x">{quantity}</span>
      <button
        onClick={() => handleQuantityChange("increase")}
        className="p-2 hover:bg-gray-100"
      >
        <Plus size={20} />
      </button>
    </div>
  </div>
</div>
          {/* Add to Cart */}
<div className="flex space-x-4">
  <button
    onClick={handleAddToCart}
    // disabled={product.status==="inactive"}
    className={`flex-1 py-3 rounded-lg transition-colors ${
      product.status!=="inactive"
        ? "bg-green-800 text-white hover:bg-green-600"
        : "bg-blue-500 text-white"
    }`}
  >
    {product.status==="inactive" ? (t("SoldOut") || "SOLD OUT") : isInCart ? t("UpdateCart") : t("AddtoCart")}
  </button>
  <button className="p-3 border rounded-lg hover:bg-gray-50">
    <Heart />
  </button>
  <button onClick={handleShare} className="p-3 border rounded-lg hover:bg-gray-50">
    <Share2 />
  </button>
</div>
          <hr></hr>
          <div className="">
            <h3>Description</h3>
          <p className="text-gray-700"> {i18n.dir() === "rtl"?  product.ar_description : product.description} </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
